import { FC } from 'react';
import { clamp } from 'lodash';
import { BREAKPOINTS } from '../../../utils/styles/breakpoints';
import { IconGallery } from '../../icon/IconGallery';
import { IconGalleryShadow } from '../../icon/IconGalleryShadow';
import { IconProduct } from '../../icon/IconProduct';
import { IconProductShadow } from '../../icon/IconProductShadow';
import { IconVideo } from '../../icon/IconVideo';
import { IconVideoShadow } from '../../icon/IconVideoShadow';
import { IconProps } from '../../icon/createIconComponent';
import { PRODUCT_PREVIEW_HEIGHT } from '../ProductsPreview/constants';
import { PostUI } from '../types';
import {
    DEFAULT_ICON_PROPS,
    ICONS_GAP,
    POST_GRID_CARD_FOOTER_HEIGHT,
    POST_COLLECTION_GRID_CARD_RATIO,
} from './constants';
import { CalculateGridCardHeightOptions } from './types';

export const calculateGridCardHeight = (
    width: number,
    slides: PostUI['content'] = [],
    postType: PostUI['postType'],
    options?: CalculateGridCardHeightOptions,
) => {
    const { withoutFooter = false, withProductsPreview = false } = options ?? {};
    const [firstSlide] = slides;
    const [firstMedia] = firstSlide?.media ?? [];
    let ratio = clamp((firstMedia?.width || 1) / (firstMedia?.height || 1), 9 / 16, 16 / 9);

    if (postType === 'collection') {
        ratio = POST_COLLECTION_GRID_CARD_RATIO;
    }

    const height = width / ratio;
    const finalHeight =
        window.innerWidth < BREAKPOINTS.sm ? height : Math.min(height, window.innerHeight);

    const extraHeight =
        (withoutFooter ? 0 : POST_GRID_CARD_FOOTER_HEIGHT) +
        (withProductsPreview ? PRODUCT_PREVIEW_HEIGHT : 0);

    // Если ширина больше высоты, то делаем ее равной высоте, чтобы карточка была квадратной
    return Math.max(finalHeight, width) + extraHeight;
};

export const getPostCardGridIcons = (
    post: PostUI,
    options: { redesign?: boolean; withProductsPreview?: boolean },
) => {
    const icons: Array<FC<IconProps>> = [];
    const { redesign, withProductsPreview } = options;

    if (post.content.length > 1) {
        redesign ? icons.push(IconGalleryShadow) : icons.push(IconGallery);
    }

    if (post.content[0].type === 'video') {
        redesign ? icons.push(IconVideoShadow) : icons.push(IconVideo);
    }

    if (post.products?.items.length > 0 && !withProductsPreview) {
        redesign ? icons.push(IconProductShadow) : icons.push(IconProduct);
    }

    return icons;
};

export const getIconOffset = (index: number) =>
    `${
        // Сумма всех предидущих иконок
        index * DEFAULT_ICON_PROPS.size +
        // Отступы между иконками
        ICONS_GAP * (index + 1) +
        // Общий отступ справа
        ICONS_GAP
    }px`;
